import React from 'react';
import { Table, Button, Space, Tag, Image, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { EditOutlined, DeleteOutlined, SendOutlined, UndoOutlined } from '@ant-design/icons';

const BlogPostTable = ({ blogPosts, onEdit, onDelete, onToggleStatus }) => {
  if (!blogPosts || blogPosts.length === 0) {
    return null; // Handled by parent component
  }

  const columns = [
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Post</span>,
      key: 'post',
      render: (_, item) => {
        const title = item?.title || 'Untitled';

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Image
              src={item.coverImage}
              alt={title}
              width={60}
              height={40}
              style={{
                objectFit: 'cover',
                borderRadius: '4px'
              }}
              fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='40'%3E%3Crect width='100%25' height='100%25' fill='%23e6d5f0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23470172' font-size='12'%3EImg%3C/text%3E%3C/svg%3E"
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 600, color: '#470172' }}>
                {title}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#8b8b8b' }}>
                <Avatar
                  src={item.authorImage || undefined}
                  icon={!item.authorImage && <UserOutlined />}
                  size={18}
                />
                by {item.author || 'AID Team'}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Tags</span>,
      dataIndex: 'tags',
      key: 'tags',
      responsive: ['lg'],
      render: (tags) => (
        <Space size={[4, 4]} wrap>
          {Array.isArray(tags) && tags.length > 0
            ? tags.slice(0, 3).map((tag) => (
                <Tag key={tag} style={{ fontFamily: 'Rubik, sans-serif', fontSize: '12px' }}>{tag}</Tag>
              ))
            : <span style={{ color: '#bbb', fontFamily: 'Rubik, sans-serif', fontSize: '13px' }}>—</span>}
        </Space>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Views</span>,
      dataIndex: 'views',
      key: 'views',
      responsive: ['md'],
      render: (views) => (
        <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#470172' }}>
          {views || 0}
        </span>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Status</span>,
      key: 'status',
      responsive: ['md'],
      render: (_, item) => (
        <Tag
          color={item.isPublished ? 'success' : 'default'}
          style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400 }}
        >
          {item.isPublished ? 'Published' : 'Draft'}
        </Tag>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Actions</span>,
      key: 'actions',
      align: 'right',
      render: (_, item) => (
        <Space size="small">
          <Button
            type="text"
            icon={item.isPublished ? <UndoOutlined /> : <SendOutlined />}
            title={item.isPublished ? 'Unpublish' : 'Publish'}
            onClick={() => onToggleStatus(item._id)}
            style={{
              color: '#470172',
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(item)}
            style={{
              color: '#470172',
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(item._id)}
            style={{
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={blogPosts}
      rowKey="_id"
      scroll={{ x: 'max-content' }}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        style: { fontFamily: 'Rubik, sans-serif' }
      }}
      style={{ fontFamily: 'Rubik, sans-serif' }}
    />
  );
};

export default BlogPostTable;
